module.exports = __webpack_public_path__ + "static/media/Cats Eyes 01_FRANSKA-mixdown.93b10dca.mp3";